'use client';

import { Alert } from '@wolfejs/ui/Alert';
import { AdminPageHeader } from '../AdminPageHeader/AdminPageHeader';
import { BalanceCard } from './BalanceCard';
import { FundNoticeCard } from './FundNoticeCard';
import type { FundsProps } from './types';

export const Funds = ({ fundModes, balanceInfo, balanceError }: FundsProps) => {
  return (
    <div className="flex flex-col gap-8">
      <AdminPageHeader breadcrumbs={false} pageName="Funds" guideMe={false} />
      {balanceError && (
        <Alert color="error">
          There was an error getting your balance at this time. Please contact customer support to ensure your account
          is completely set up &amp; approved.
        </Alert>
      )}
      <BalanceCard balanceInfo={balanceInfo} />
      <FundNoticeCard fundModes={fundModes} />
    </div>
  );
};
